import { Descriptions } from "antd";

import { Wrapper } from "./styles";
import { Button } from "antd";

import { useHistory } from "react-router-dom";
export function ViewFichaEntidade({ entidade }) {
  const isPendenteChefeIme =
    !entidade.statusAutorizacaoChefeImediato ||
    entidade.statusAutorizacaoChefeImediato === "PENDENTE";
  const isPendenteSip3w =
    !entidade.statusAutorizacaoComissaoSip3w ||
    entidade.statusAutorizacaoComissaoSip3w === "PENDENTE";
  const isPendenteInteligencia =
    !entidade.statusAutorizacaoInteligencia ||
    entidade.statusAutorizacaoInteligencia === "PENDENTE";
  const isSip = entidade.sistema === "SIP3W";
  const isPendenteSecretario =
    (!entidade.statusAutorizacaoSecretario && !isSip) ||
    (entidade.statusAutorizacaoSecretario === "PENDENTE" && !isSip);
  const isPendenteCotic =
    !entidade.statusFuncCotic || entidade.statusFuncCotic === "PENDENTE";

  const history = useHistory();
  return (
    <Wrapper>
      <br />
      <br />

      <div>
        <h3>{entidade.sistema ? entidade.sistema.replace("_", " ") : null}</h3>
        <Descriptions>
          <Descriptions.Item label="Nome">{entidade.nome}</Descriptions.Item>
          <Descriptions.Item label="CPF">{entidade.cpf}</Descriptions.Item>
          <Descriptions.Item label="Sistema">
            {entidade.sistema ? entidade.sistema.replace("_", " ") : null}
          </Descriptions.Item>
          <Descriptions.Item label="Nivel">{entidade.nivel}</Descriptions.Item>
        </Descriptions>
      </div>
      <div class="Timeline">
        <svg height="5" width="50">
          <line
            x1="0"
            y1="0"
            x2="50"
            y2="0"
            styles={{ stroke: "#004165", strokeWidth: 5 }}
          />
          Sorry, your browser does not support inline SVG.
        </svg>

        <div class="event1">
          <div class="event1Bubble">
            <br />
            <div class="eventTitle">Solicitação Criada</div>
            <div class="eventTime">
              {/* <div class="DayDigit">02</div> */}
              <div class="Day">
                {new Date(entidade.dataCadastro).toLocaleDateString()}
                {/* <div class="MonthYear">february 2016</div> */}
              </div>
            </div>
          </div>
          {/* <div class="eventAuthor">by Youri Nelson</div> */}
          <svg height="20" width="20">
            <circle cx="10" cy="11" r="5" fill="#004165" />
          </svg>
          <div class="time">
            {new Date(entidade.dataCadastro).toLocaleTimeString()}
          </div>
        </div>

        <svg height="5" width="150">
          <line
            x1="0"
            y1="0"
            x2="150"
            y2="0"
            style={{ stroke: "#004165", strokeWidth: 5 }}
          />
          Sorry, your browser does not support inline SVG.
        </svg>

        <div class="event2">
          <div class="event2Bubble">
            <div class="eventTitle">Chefe Imediato</div>
            <div class="eventTime">
              {/* <div class="DayDigit">17</div> */}
              <div class="Day">
                {isPendenteChefeIme
                  ? "Aguardando análise"
                  : entidade.statusAutorizacaoChefeImediato}
                <br />
                {entidade.dataAtualizacaoChefeImediato
                  ? new Date(
                      entidade.dataAtualizacaoChefeImediato
                    ).toLocaleString()
                  : null}
                {/* <div class="MonthYear">April 2016</div> */}
              </div>
            </div>
          </div>

          {isPendenteChefeIme && <div class="now">AQUI</div>}

          {!isPendenteChefeIme && (
            <>
              <svg height="20" width="20">
                <circle cx="10" cy="11" r="5" fill="#004165" />
              </svg>
            </>
          )}
        </div>

        {isSip && (
          <>
            <svg height="5" width="170">
              <line
                x1="0"
                y1="0"
                x2="170"
                y2="0"
                style={{
                  stroke: !isPendenteChefeIme
                    ? "#004165"
                    : "rgba(162, 164, 163, 0.37",
                  strokeWidth: 5,
                }}
              />
              Sorry, your browser does not support inline SVG.
            </svg>

            <div
              class={`event2 ${
                (!isPendenteChefeIme && isPendenteSip3w) ||
                entidade.statusAutorizacaoChefeImediato === "REPROVADO"
                  ? "futureOpacity"
                  : ""
              }`}
            >
              <div class="event2Bubble">
                <div class="eventTitle">SIP3W</div>
                <div class="eventTime">
                  {/* <div class="DayDigit">17</div> */}
                  <div class="Day">
                    {isPendenteSip3w
                      ? "Aguardando análise"
                      : entidade.statusAutorizacaoComissaoSip3w}
                    <br />
                    {entidade.dataAtualizacaoComissaoSip3w
                      ? new Date(
                          entidade.dataAtualizacaoComissaoSip3w
                        ).toLocaleString()
                      : null}

                    {/* <div class="MonthYear">April 2016</div> */}
                  </div>
                </div>
              </div>
              {!isPendenteChefeIme && isPendenteSip3w && (
                <div class="now">AQUI</div>
              )}
              {isPendenteChefeIme && isPendenteSip3w && (
                <svg height="20" width="20">
                  <circle
                    cx="10"
                    cy="11"
                    r="5"
                    fill="rgba(162, 164, 163, 0.37"
                  />
                </svg>
              )}
              {!isPendenteSip3w && (
                <>
                  <svg height="20" width="20">
                    <circle cx="10" cy="11" r="5" fill="#004165" />
                  </svg>
                </>
              )}
            </div>
          </>
        )}

        <svg height="5" width="170">
          <line
            x1="0"
            y1="0"
            x2="170"
            y2="0"
            style={{
              stroke:
                (isSip && !isPendenteSip3w) || (!isSip && !isPendenteChefeIme)
                  ? "#004165"
                  : "rgba(162, 164, 163, 0.37",
              strokeWidth: 5,
            }}
          />
          Sorry, your browser does not support inline SVG.
        </svg>

        <div
          class={`event2 ${
            entidade.statusAutorizacaoComissaoSip3w !== "REPROVADO" &&
            entidade.statusAutorizacaoChefeImediato !== "REPROVADO" &&
            ((isSip && !isPendenteSip3w) || (!isSip && !isPendenteChefeIme))
              ? ""
              : "futureOpacity"
          } `}
        >
          <div class="event2Bubble">
            <div class="eventTitle">INTELIGÊNCIA</div>
            <div class="eventTime">
              {/* <div class="DayDigit">17</div> */}
              <div class="Day">
                {isPendenteInteligencia
                  ? "Aguardando análise"
                  : entidade.statusAutorizacaoInteligencia}
                <br />
                {entidade.dataAtualizacaoInteligencia
                  ? new Date(
                      entidade.dataAtualizacaoInteligencia
                    ).toLocaleString()
                  : null}

                {/* <div class="MonthYear">April 2016</div> */}
              </div>
            </div>
          </div>

          {isPendenteInteligencia &&
            ((isSip && !isPendenteSip3w) ||
              (!isSip && !isPendenteChefeIme)) && <div class="now">AQUI</div>}
          {isPendenteInteligencia &&
            ((isSip && isPendenteSip3w) || (!isSip && isPendenteChefeIme)) && (
              <svg height="20" width="20">
                <circle cx="10" cy="11" r="5" fill="rgba(162, 164, 163, 0.37" />
              </svg>
            )}
          {!isPendenteInteligencia && (
            <svg height="20" width="20">
              <circle cx="10" cy="11" r="5" fill="#004165" />
            </svg>
          )}
        </div>

        <svg height="5" width="170">
          <line
            x1="0"
            y1="0"
            x2="170"
            y2="0"
            style={{
              stroke: !isPendenteInteligencia
                ? "#004165"
                : "rgba(162, 164, 163, 0.37",
              strokeWidth: 5,
            }}
          />
          Sorry, your browser does not support inline SVG.
        </svg>

        <div
          class={`event2 ${
            entidade.statusAutorizacaoInteligencia !== "REPROVADO" &&
            !isPendenteInteligencia
              ? ""
              : "futureOpacity"
          } `}
        >
          {!isSip && (
            <div class="event2Bubble">
              <div class="eventTitle">EXECUTIVO </div>
              <div class="eventTime">
                {/* <div class="DayDigit">17</div> */}
                <div class="Day">
                  {isPendenteSecretario
                    ? "Aguardando análise"
                    : entidade.statusAutorizacaoSecretario}
                  <br />
                  {entidade.dataAtualizacaoSecretario
                    ? new Date(
                        entidade.dataAtualizacaoSecretario
                      ).toLocaleString()
                    : null}
                  {/* <div class="MonthYear">April 2016</div> */}
                </div>
              </div>
            </div>
          )}

          {!isPendenteInteligencia && isPendenteSecretario && (
            <div class="now">AQUI</div>
          )}
          {isPendenteInteligencia && isPendenteSecretario && (
            <svg height="20" width="20">
              <circle cx="10" cy="11" r="5" fill="rgba(162, 164, 163, 0.37" />
            </svg>
          )}
          {!isPendenteSecretario && (
            <>
              <svg height="20" width="20">
                <circle cx="10" cy="11" r="5" fill="#004165" />
              </svg>
            </>
          )}
        </div>

        <svg height="5" width="180">
          <line
            x1="0"
            y1="0"
            x2="180"
            y2="0"
            style={{
              stroke: !isPendenteSecretario
                ? "#004165"
                : "rgba(162, 164, 163, 0.37",
              strokeWidth: 5,
            }}
          />
          Sorry, your browser does not support inline SVG.
        </svg>

        <div
          class={`event2 ${
            entidade.statusAutorizacaoSecretario !== "REPROVADO" &&
            !isPendenteCotic &&
            !isPendenteSecretario
              ? ""
              : "futureOpacity"
          } `}
        >
          <div class="event2Bubble">
            <div class="eventTitle">COTIC</div>
            <div class="eventTime">
              {/* <div class="DayDigit">17</div> */}
              <div class="Day">
                {isPendenteCotic
                  ? "Aguardando liberação"
                  : entidade.statusFuncCotic}
                <br />
                {entidade.dataFuncCotic
                  ? new Date(entidade.dataFuncCotic).toLocaleString()
                  : null}
              </div>
            </div>
          </div>

          {!isPendenteSecretario && isPendenteCotic && (
            <div class="now">AQUI</div>
          )}
          {isPendenteCotic && isPendenteSecretario && (
            <svg height="20" width="20">
              <circle cx="10" cy="11" r="5" fill="rgba(162, 164, 163, 0.37" />
            </svg>
          )}
          {!isPendenteCotic && (
            <>
              <svg height="20" width="20">
                <circle cx="10" cy="11" r="5" fill="#004165" />
              </svg>
            </>
          )}
        </div>

        <svg height="5" width="150">
          <line
            x1="0"
            y1="0"
            x2="150"
            y2="0"
            style={{
              stroke:
                !isPendenteSecretario && !isPendenteCotic
                  ? "#004165"
                  : "rgba(162, 164, 163, 0.37)",
              strokeWidth: 5,
            }}
          />
          Sorry, your browser does not support inline SVG.
        </svg>

        <div
          class={`event1 ${
            !isPendenteSecretario && !isPendenteCotic ? "" : "futureOpacity"
          }`}
        >
          <div class="event1Bubble">
            <br />
            <div class="eventTitle">Finalizado</div>
            <div class="eventTime">
              {/* <div class="DayDigit">02</div> */}
              <div class="Day">
                {"Liberado acesso"}
                {/* <div class="MonthYear">february 2016</div> */}
              </div>
            </div>
          </div>
          {/* <div class="eventAuthor">by Youri Nelson</div> */}
          <svg height="20" width="20">
            <circle cx="10" cy="11" r="5" fill="#004165" />
          </svg>
        </div>
      </div>
      <div className="buttonFicha">
        <Button onClick={() => history.push(`/ficha/${entidade.id}`)}>
          Visualizar Ficha
        </Button>
      </div>
    </Wrapper>
  );
}
